import React, { useEffect, useRef } from "react";
import "./FinancialPartners.css";

import kotak from "../../../Image/download1 (2).png";
import shriram from "../../../Image/shriram.png";
import bajaj from "../../../Image/Bajaj Finserv Logo - 480x480.png";
import Vpay from "../../../Image/download (1).png";
import loantap from "../../../Image/download.png";

const partners = [kotak, shriram, bajaj, Vpay, kotak, loantap];

const FinancialPartners = () => {
  const sliderRef = useRef(null);

  useEffect(() => {
    let scrollAmount = 0;

    const interval = setInterval(() => {
      if (!sliderRef.current) return;

      scrollAmount += 1;
      sliderRef.current.scrollLeft += 1;

      if (
        sliderRef.current.scrollLeft >=
        sliderRef.current.scrollWidth - sliderRef.current.clientWidth
      ) {
        sliderRef.current.scrollLeft = 0;
        scrollAmount = 0;
      }
    }, 20);

    return () => clearInterval(interval);
  }, []);

  return (
    <section className="partners-section">
      <span className="tag">TRUSTED PARTNERS</span>

      <h2>
        Our Financial <span>Partners</span>
      </h2>

      <p>
        Partnering with India's most trusted financial institutions to bring you
        exclusive benefits
      </p>

      <div className="slider-wrapper" ref={sliderRef}>
        <div className="slider">
          {partners.map((logo, index) => (
            <div className="partner-card" key={index}>
              <div className="logo-box">
                <img src={logo} alt="partner" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FinancialPartners;
